// extracted by mini-css-extract-plugin
module.exports = {"socialBlock":"SocialButtons_socialBlock__FUUIN","btnSocial":"SocialButtons_btnSocial__yzTJD"};